module.exports = {
  models: require('./models'),
  Insight: require('./insight')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/bitcore-explorers/lib/index.js
// module id = Djwq
// module chunks = 0